module.exports = __webpack_public_path__ + "static/media/CovetrusAvimark.d664c034.png";